import React from "react";
import { Leaf, Map, BarChart3, UserCheck,ClipboardList  } from "lucide-react";
import l2 from '../assets/smartfarm.png'
import l1 from '../assets/YourDroneFlyingAlways.webp'
import ReusableBanner from "../Components/Banner";
import GridComp from "../Components/GridComp";
import HeadingBlock from "../Components/HeadingBlock";
import { Helmet } from "react-helmet";
const SmartFarming = () => {
    const services = [
  {
    icon: <Leaf className="w-10 h-10 text-green-800" />,
    title: "Crop Health Analysis",
    desc: "Spot diseases or stress early with aerial monitoring.",
    gradient: "from-green-400 to-green-600",
  },
  {
    icon: <Map className="w-10 h-10 text-green-800" />,
    title: "Soil & Resource Mapping",
    desc: "Use water, seeds, and fertilizers more efficiently.",
    gradient: "from-blue-400 to-blue-600",
  },
  {
    icon: <BarChart3 className="w-10 h-10 text-green-800" />,
    title: "Yield Forecasting",
    desc: "Predict outcomes and plan better.",
    gradient: "from-yellow-400 to-yellow-600",
  },
  {
    icon: <ClipboardList className="w-10 h-10 text-green-800" />,
    title: "Custom Advisory",
    desc: "Tailored guidance for your farm, your crop, and your goals.",
    gradient: "from-purple-400 to-purple-600",
  },
];

  const features = [
    {
      icon: <Leaf className="w-8 h-8 text-green-600" />,
      title: "Crop Health Analysis",
      desc: "Spot diseases or stress early with aerial monitoring.",
      img: l1,
    },
    {
      icon: <Map className="w-8 h-8 text-green-600" />,
      title: "Soil & Resource Mapping",
      desc: "Use water, seeds, and fertilisers more efficiently.",
      img: l1,
    },
    {
      icon: <BarChart3 className="w-8 h-8 text-green-600" />,
      title: "Yield Forecasting",
      desc: "Predict outcomes and plan better.",
      img: l1,
    },
    {
      icon: <UserCheck className="w-8 h-8 text-green-600" />,
      title: "Custom Advisory",
      desc: "Tailored guidance for your farm, your crop, and your goals.",
      img: l1,
    },
  ];

  return (
    <div>
       <Helmet>
        <title>Smart Farming With Advisory & Data Insights</title>

        <meta
          name="description"
          content="At Drone Didi, your drone doesn’t just fly, it also collects valuable data. With our consulting and analytics services, we turn that data into simple and practical insights for you to take better decisions."
        />

        <link
          rel="canonical"
          href="https://dronedidi.co.in/smartfarming"
        />
      </Helmet>
      {/* ✅ Banner Section */}
    
<ReusableBanner
  bgImage={l1}
  title={<span> Keep Your Drone <span className="text-green-400">Flying,</span> Always </span>}
  subtitle="From quick health checks to complete repairs — we ensure your drone stays mission-ready without heavy costs."
  height="h-[70vh]"
  fixedAttachment={true}
  align="center"
  // cta={{ text: "Get started", href: "/signup" }}
/>
<div className="max-w-[80%] mx-auto">
<section className="relative py-12 ">
<GridComp
  title="Smart Farming with Advisory &"
  highlight="Data Insights"
  paragraphs={[
    "'Smart data, Smarter farming'. Your drone doesn't just fly; it also collects valuable data. With our consulting and analytics services, we turn that data into simple and practical insights to help you make better decisions in the field.",
  ]}
  image={l2}
  align="left"
  reverse={true}
  titleColor="text-black"         // Default = white
  highlightColor="text-orange-400" // Custom highlight color
/>
<div className="absolute top-10 right-0 w-60 h-60 bg-green-400/30 rounded-full "></div>
  <div className="absolute bottom-0 lg:left-10 w-40 h-40 bg-orange-700/50 rounded-full"></div>
</section>
<section className="bg-green-100 p-10">
     <HeadingBlock
        subtitle="Smarter Solutions for Every Farm"
        title="Solutions We Deliver"
          align="center"

        // highlight="Agency"
      />

       

        <div className="grid md:grid-cols-2 lg:grid-cols-4 mt-10 gap-8">
          {services.map((s, i) => (
            <div
              key={i}
              className="relative group bg-white rounded-2xl shadow-md border border-gray-100 p-6 transition-all hover:shadow-xl hover:-translate-y-1"
            >
              {/* Icon with gradient circle */}
              <div
                className={`p-4 rounded-full bg-gradient-to-r from-green-200 to-green-500 text-white w-fit mb-4`}
              >
                {s.icon}
              </div>

              <h3 className="text-xl font-semibold mb-3 group-hover:text-green-600 transition">
                {s.title}
              </h3>
              <p className="text-gray-600">{s.desc}</p>

              {/* Bottom gradient line on hover */}
              <div
                className={`absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r from-green-400 to-green-600 transition-all duration-300 group-hover:w-full`}
              ></div>
            </div>
          ))}
        </div>
    </section>
</div>
    <section className="relative my-10">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-fixed bg-center"
        style={{ backgroundImage: `url(${l1})` }}
      ></div>

      {/* Slanted overlay */}
      <div className="absolute inset-0 bg-black/60 clip-slant"></div>

  {/* Content */}
<div className="relative z-10  px-6 lg:px-20 py-24 flex items-center">
  <div className="text-left text-white max-w-2xl xl:max-w-3xl">
    <h2 className="text-3xl md:text-5xl font-bold leading-tight drop-shadow-[5px_0px_1px_black]">
      Why It Works?
    </h2>
    <p className="mt-4 text-xl text-gray-200 drop-shadow-[3px_0px_1px_black]">
      Data takes the guesswork out of farming. Instead of reacting late to problems, you act early. Instead of wasting resources, you optimize them. Instead of hoping for good yields, you plan for them. With smart insights, your farm becomes more resilient and your income more stable.
    </p>

    {/* Closing Note */}
    <div className="mt-10 border-l-4 border-green-400 pl-6">
      <p className="italic text-xl text-gray-100 drop-shadow-[3px_0px_1px_black]">
        "We help you see beyond the field with insights that save money, increase yield, and make your farming smarter every season."
      </p>
    </div>
  </div>
</div>

    </section>
    </div>
  );
};

export default SmartFarming;
